import React from 'react';

import PropTypes from 'prop-types';
import { Dropdown, Button } from 'semantic-ui-react';

import { QuestionGroupType } from 'components/modules/questions/types';
import { getGroupOptions } from 'components/modules/questions/utils';

import './GroupSelector.scss';

const propTypes = {
  groups: PropTypes.arrayOf(QuestionGroupType).isRequired,
  selectedGroups: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

const defaultProps = {
  disabled: false,
};

export default function GroupSelector({
  groups,
  selectedGroups,
  onChange,
  onConfirm,
  onCancel,
  disabled,
}) {
  const groupOptions = getGroupOptions(groups);
  return (
    <div className="group-assignment">
      <Dropdown
        placeholder="Select groups to assign"
        fluid
        multiple
        selection
        options={groupOptions}
        value={selectedGroups}
        onChange={onChange}
        disabled={disabled}
      />
      <Button className="secondary-navy" content="Assign" onClick={onConfirm} disabled={disabled} />
      <Button
        className="action-button-gray"
        content="Cancel"
        onClick={onCancel}
        disabled={disabled}
      />
    </div>
  );
}

GroupSelector.propTypes = propTypes;
GroupSelector.defaultProps = defaultProps;
